import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Typography } from '@mui/material'

import { RadioSelect, PetRowItem, Loading } from '../../components'

import { useFetchNewestPets } from '../../services/queries'

import './NewPets.scss'

export const NewPets = () => {
  const navigate = useNavigate()
  const [type, setType] = useState<'Cat' | 'Dog'>('Dog')
  const { data: pets = [], isLoading } = useFetchNewestPets(type)

  return (
    <div className="new-pets-page">
      <Typography variant="h3">New Pets</Typography>
      <RadioSelect
        options={[
          { label: 'Dogs', value: 'Dog' },
          { label: 'Cats', value: 'Cat' }
        ]}
        value={type}
        setValue={setType}
      />
      <div className="new-pets-container">
        {isLoading ? (
          <Loading />
        ) : (
          pets.map((p, i) => (
            <PetRowItem
              key={`new-pet-${i}`}
              pet={p}
              onClick={() => navigate(`/pets/${p.pet_id}`)}
            />
          ))
        )}
      </div>
    </div>
  )
}
